import Cookies from "js-cookie";

function getLanguageCookieOpts() {
  const opts = {
    sameSite: "lax",
    path: "/",
    expires: 30,
    secure:
      typeof window !== "undefined" && window.location.protocol === "https:",
  };
  const envDomain = process.env.REACT_APP_COOKIE_DOMAIN;
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]";
  if (envDomain && !isLocalhost) {
    opts.domain = envDomain;
  }
  return opts;
}

/**
 * Keeps document dir/lang and language cookie aligned with i18n on every changeLanguage().
 */
export function syncLanguageDocument(lng) {
  if (!lng || typeof document === "undefined") return;
  Cookies.set("language", lng, getLanguageCookieOpts());
  const dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
  document.documentElement.setAttribute("dir", dir);
  document.body.dir = dir;
}
